import { delay, put, takeLatest } from 'redux-saga/effects';
import {
  CHANGE_SCREEN,
  ANIMATE_TO_SCREEN,
  ANIMATE_TO_SCREEN_AND_BEEP,
  SET_CARD_READER_ZOOM_LEVEL,
  SET_CARD_POSITION,
} from './ui/actions';
import { getCardReaderZoomLevel, getCardPosition } from './ui/helpers';
import {
  ACTIVATE_GREEN_LIGHT,
  // DEACTIVATE_CARD_LIGHT,
  DEACTIVATE_GREEN_LIGHT,
  BEEP,
} from './cardReader/actions';
import {
  CARD_POSITION_READ,
  CARD_POSITION_READ_FINISHED,
} from '../components/CardAndHand';
import beepSoundFile from '../assets/audio/card-reader-accept-beep.mp3';

const beepSound = new Audio(beepSoundFile);

function* beep() {
  try {
    yield beepSound.play();
  } catch (e) {
    console.error('BEEP FAILED', e);
  }
}

function* animateToScreen(action) {
  try {
    const screen = action.payload;
    const cardReaderZoomLevel = getCardReaderZoomLevel(screen);
    const cardPosition = getCardPosition(screen);
    yield put({ type: CHANGE_SCREEN, payload: screen });
    yield put({ type: SET_CARD_READER_ZOOM_LEVEL, payload: cardReaderZoomLevel }); // eslint-disable-line
    yield put({ type: SET_CARD_POSITION, payload: cardPosition });
  } catch (e) {
    console.error('CHANGE_SCREEN FAILED', e);
  }
}

function* animateToScreenAndBeep(action) {
  try {
    const screen = action.payload;
    const cardReaderZoomLevel = getCardReaderZoomLevel(screen);
    yield put({ type: SET_CARD_READER_ZOOM_LEVEL, payload: cardReaderZoomLevel }); // eslint-disable-line
    yield put({ type: SET_CARD_POSITION, payload: CARD_POSITION_READ });
    yield delay(500);
    yield put({ type: BEEP });
    yield delay(250);
    yield put({ type: CHANGE_SCREEN, payload: screen });
    yield put({ type: ACTIVATE_GREEN_LIGHT });
    yield delay(2000);
    yield put({ type: SET_CARD_POSITION, payload: CARD_POSITION_READ_FINISHED }); // eslint-disable-line
    yield delay(1500);
    yield put({ type: DEACTIVATE_GREEN_LIGHT });
    // yield put({ type: DEACTIVATE_CARD_LIGHT });
  } catch (e) {
    console.error('CHANGE_SCREEN_AND_BEEP FAILED', e);
  }
}

function* sagas() {
  yield takeLatest(BEEP, beep);
  yield takeLatest(ANIMATE_TO_SCREEN, animateToScreen);
  yield takeLatest(ANIMATE_TO_SCREEN_AND_BEEP, animateToScreenAndBeep);
}

export default sagas;
